import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import Text from "../../../shared/components/Text";
import { formatMoney } from "@nemuru-eng/js-api-client";

export const Conditions = ({
  loanConditions,
  hasMultiplePricings,
  invalidTerm,
}) => {
  const { palette, breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down("sm"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (loanConditions) {
      setLoading(false);
    }
    return () => {
      setLoading(false);
    };
  }, [loanConditions]);

  return (
    <Box py={1} display={"flex"} flexDirection={"column"} alignItems={"center"}>
      {loading ? (
        <Box
          display={"flex"}
          flexDirection={"row"}
          alignItems={"center"}
          gridGap={"12px"}
          minHeight={isMobile ? "70px" : "84px"}
        >
          <CircularProgress size={24} />
          <Typography
            color={"textSecondary"}
            variant={"subtitle1"}
            align={"center"}
          >
            <Text tId={"CALCULATING_CONDITIONS"} />
          </Typography>
        </Box>
      ) : (
        <>
          <Typography
            style={{ color: palette.text.title }}
            variant={isMobile ? "h5" : "h4"}
            align={"center"}
          >
            {invalidTerm ? (
              <Box>- €</Box>
            ) : (
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                gridGap={8}
              >
                {hasMultiplePricings && <Text strong tId={"FROM"} />}
                <Text
                  strong
                  tId={"MONEY_PER_MONTH"}
                  dynamicDataTexts={[
                    formatMoney({
                      value: loanConditions.quota,
                      currency: loanConditions.currency,
                    }),
                  ]}
                />
              </Box>
            )}
          </Typography>
        </>
      )}
    </Box>
  );
};
